import { render, staticRenderFns } from "./NitrogenDialog.vue?vue&type=template&id=5210c4ef&"
import script from "./NitrogenDialog.vue?vue&type=script&lang=js&"
export * from "./NitrogenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports